import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';

import'rxjs/add/operator/toPromise';
import { Observable } from 'rxjs/Observable';
import'rxjs/add/operator/catch';
import'rxjs/add/operator/map';
import'rxjs/add/operator/mergeAll';
import'rxjs/add/operator/toArray';
import'rxjs/add/operator/filter';
import'rxjs/add/operator/combinelatest';
import'rxjs/add/operator/withlatestfrom';

import { ConfigService } from '../config/config.service';
import { Product } from './product';
import { ProductProductCategoriesService } from '../product-categories/product-product-categories.service';
import { ProductProductCategory } from '../product-categories/product-product-category';
import { ProductCategory } from '../product-categories/product-category';
import { ContextService } from '../context/context.service';
import { LoggingService } from '../loging/logging.service';
export class ProductsService {
    title = 'Products Service';
private productsUrl = '';
private config: any;
private productProductCategories: Observable<ProductProductCategory[]>;
private headers = new Headers({ 'Content-Type': 'application/json' });
private products: Observable<Product[]>;
/**
 * @param {?} http
 * @param {?} configService
 * @param {?} productProductCategoriesService
 * @param {?} contextService
 * @param {?} loggingService
 */
constructor(
private http: Http,
private configService: ConfigService,
private productProductCategoriesService: ProductProductCategoriesService,
private contextService: ContextService,
private loggingService: LoggingService
    ) {
        this.configService.getConfig((configuration: any) => {
            this.config = configuration;
            this.productsUrl = this.config.baseUrl + '/products';

            this.loadProductProductCategories();
            this.loadProducts();
        });
    }
/**
 * @param {?} error
 * @return {?}
 */
private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
/**
 * @return {?}
 */
loadProductProductCategories(): void {
        this.productProductCategories = this.productProductCategoriesService.getProductProductCategories();
    }
/**
 * @return {?}
 */
loadProducts(): void {
        this.loadProductProductCategories();
        this.products =
            this.contextService.selectedCategory
                .asObservable()
                .combineLatest(
                    this.http.get(this.productsUrl)
                        .map(res => res.json()),
                    this.productProductCategories,
                    (
                        selectedCategory: string,
                        products: Product[],
                        productProductCategories: ProductProductCategory[]
                    ) => {

                        return {
                            products: products,
                            productProductCategories: productProductCategories, selectedCategory: selectedCategory
                        };
                    })
                .map(
                    (latest: any) => {
                        // this.loggingService.log('filter latest = ');
                        // this.loggingService.log(latest);

                        if (latest.selectedCategory !== 'All Products') {
                            let /** @type {?} */ productProductCategories: ProductProductCategory[] = latest.productProductCategories.filter(
                                (productProductCategory: ProductProductCategory) => {
                                    return (productProductCategory.ProductCategory && (productProductCategory.ProductCategory.Key === latest.selectedCategory));
                                }
                            );

                            // this.loggingService.log('productProductCategories = ');
                            // this.loggingService.log(productProductCategories);

                            if (productProductCategories) {
                                var /** @type {?} */ returnedProducts: Product[] = new Array<Product>();

                                productProductCategories.forEach(
                                    productProductCategory => {
                                        if(!productProductCategory.Product){
                                            // JJH: TODO: Need to send an e-mail to myself to fix these
                                            this.loggingService.log("product.service.ts: loadProducts(): null product for productProductCategory = ", productProductCategory);
                                        }
                                        returnedProducts.push(productProductCategory.Product);
                                    }
                                );
                                
                                return returnedProducts;
                            } else {
                                return [];
                            }
                        } else {
                            return latest.products;
                        }
                    });
    }
/**
 * @return {?}
 */
getProducts(): Observable<Product[]> {

        return this.products;
    }
/**
 * @param {?} id
 * @return {?}
 */
getProduct(id: string): Observable<Product> {
        const /** @type {?} */ url = `${this.productsUrl}/${id}`;
        return this.http.get(url).map(res => res.json());
    };
/**
 * @param {?} product
 * @return {?}
 */
updateProduct(product: Product): Observable<Product> {
        const /** @type {?} */ url = `${this.productsUrl}/${product.id}`;

        return this.http.put(
            url,
            JSON.stringify(product),
            {
                headers: this.headers
            }
        ).map(res => res.json());
    }
/**
 * @param {?} product
 * @return {?}
 */
createProduct(product: Product): Observable<Product> {

        return this.http.post(
            this.productsUrl,
            JSON.stringify(product),
            {
                headers: this.headers
            }
        ).map(res => res.json());
    }
/**
 * @param {?} id
 * @return {?}
 */
deleteProduct(id: string): Observable<any> {
        const /** @type {?} */ url = `${this.productsUrl}/${id}`;
        return this.http.delete(url).map(res => res.json()).catch(this.handleError);
    };

static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Http, },
{type: ConfigService, },
{type: ProductProductCategoriesService, },
{type: ContextService, },
{type: LoggingService, },
];
}

function ProductsService_tsickle_Closure_declarations() {
/** @type {?} */
ProductsService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ProductsService.ctorParameters;
/** @type {?} */
ProductsService.prototype.title;
/** @type {?} */
ProductsService.prototype.productsUrl;
/** @type {?} */
ProductsService.prototype.config;
/** @type {?} */
ProductsService.prototype.productProductCategories;
/** @type {?} */
ProductsService.prototype.headers;
/** @type {?} */
ProductsService.prototype.products;
/** @type {?} */
ProductsService.prototype.http;
/** @type {?} */
ProductsService.prototype.configService;
/** @type {?} */
ProductsService.prototype.productProductCategoriesService;
/** @type {?} */
ProductsService.prototype.contextService;
/** @type {?} */
ProductsService.prototype.loggingService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
